import React, { Component } from 'react'
import './styles.css'


const estadoInicial = {
}

class Modal extends Component {

    state = {
        ...estadoInicial,
    }
    
    componentDidMount = async () => {
    }
    
        render() {
            if (!this.props.open) {
                return(<></>);
            }

            return (
                <div className={`${this.props.className ? this.props.className : 'modal_screen'}`} styles={this.props.styles} onClick={(e) => {if (e.target == e.currentTarget) this.props.onClose()}}>
                    {this.props.children}
                </div>
            )
        }
    }

export default (Modal)